module.exports = __webpack_public_path__ + "media/images/guide-3-a136e8b4def22a462a8c96cf37c520dc.png";